module.exports = __webpack_public_path__ + "img/tour-34.bc56bd6d.png";